import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  list?: {
    imageUrl?: string;
    title?: string;
    subtitle?: string;
    description?: string;
    featureList?: {
      featureItem?: string;
    }[];
  }[];
}

const propsSchema: PropsSchemaList = [
  {
    key: 'list',
    label: 'List',
    type: types.ARRAY,
    children: [
      {
        key: 'imageUrl',
        label: 'Image Url',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
      },
      {
        key: 'featureList',
        label: 'Feature List',
        type: types.ARRAY,
        children: [
          {
            key: 'featureItem',
            label: 'Feature Item',
            type: types.TEXT,
          },
        ]
      },
    ]
  },
];

const defaultProps: Props = {
  list: [
    {
      imageUrl: 'https://genesis-cdn.ff.com/assets/emails/ff-91_silver-default.jpg',
      title: 'FF Portable Charger',
      subtitle: 'Simple Yet Powerful - The FF Portable Charger',
      description: `At Faraday Future, we are committed to providing charging solutions for every situation. 
      Our dual level FF Portable Charger is included in every FF 91. 
      Plug it into a standard dedicated household outlet to ‘top up’ your tank (Level 1 charging) or 
      have it professionally installed at home by a qualified electrician, with our charging installation partner, 
      Qmerit to achieve 9.6 kW of Level 2 charging.`,
      featureList: [
        {
          featureItem: 'Featuring:',
        },
        {
          featureItem: 'Level 1 (NEMA 5-15) 1.4 kW',
        },
        {
          featureItem: 'Level 2 (NEMA 14-50) 9.6 kW',
        },
        {
          featureItem: 'LED Charging Display with real-time charging information',
        }
      ]
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/assets/emails/ff-91_silver-default.jpg',
      title: 'Home Charging1',
      subtitle: 'Experience the Power of FF Charging Solutions',
      description: `To fully utilize FF 91’s charging capabilities,
      plug in with the FF Home Charger supporting up to 19.2kW along with a streamlined installation process to meet all your charging needs.
      The FF Home Charger is a smart Wi-Fi connected charger, designed, and manufactured for durability and longevity,
      can be installed indoors or outdoors while being compatible with most EVs. 
      FF has simplified the installation process by partnering with our charging installation partner, Qmerit. 
      The FF Home Charger will ensure you wake up fully charged.`,
      featureList: [
        {
          featureItem: 'Featuring:',
        },
        {
          featureItem: 'Level 2 Up to 19.2 kW',
        },
        {
          featureItem: 'Cable length 24-foot',
        },
        {
          featureItem: 'Disclaimer: 1 Coming in Q3 2023',
        }
      ]
    }
  ]
};

export default {
  title: 'Image Text Grid',
  id: 'ImageTextGrid',
  propsSchema,
  defaultProps,
}
